
(function () {
  if (customElements.get('intention-multilevel-nav')) return;
  class IntentionMultilevelNav extends HTMLElement {
    constructor() {
      super();
      this.mq = window.matchMedia('(max-width: 768px)');
      this.onResize = this.onResize.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
    }
    connectedCallback() {
      this.bindTriggers();
      this.setupHoverListeners();
      this.onResize();
      window.addEventListener('resize', this.onResize);
      document.addEventListener('click', this.onDocClick);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('click', this.onDocClick);
    }
    isDrawer() { return !!this.closest('.header__drawer'); }
    isMobileMode() { return this.isDrawer() || this.mq.matches; }
    bindTriggers() {
      this.navTriggers = Array.from(this.querySelectorAll('[data-nav-trigger]'));
      this.subTriggers = Array.from(this.querySelectorAll('[data-submenu-trigger]'));
      this.navTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => this.handleNavClick(e, trigger));
      });
      this.subTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => this.handleSubmenuClick(e, trigger));
      });
    }
    /* Desktop hover: position dropdowns/submenus on mouseenter */
    setupHoverListeners() {
      this.querySelectorAll('[data-nav-item]').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (this.isMobileMode()) return;
          var dropdown = item.querySelector(':scope > [data-dropdown]');
          if (dropdown) this.positionPanel(dropdown, item, 'dropdown');
        });
      });
      this.querySelectorAll('[data-dropdown-item]').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (this.isMobileMode()) return;
          var submenu = item.querySelector(':scope > [data-submenu]');
          if (submenu) this.positionPanel(submenu, item, 'submenu');
        });
      });
    }
    /* Smart positioning: cap scrollable areas to viewport.
       Uses setProperty('max-height', val, 'important') to override
       the CSS !important fallback from custom.css. */
    positionPanel(panel, parentItem, type) {
      panel.classList.remove('intention-ml--flip-left');
      panel.scrollTop = 0;

      /* Use setTimeout so the CSS :hover transition has started and
         the browser has painted the panel in its natural position.
         rAF alone fires before paint in many browsers. */
      setTimeout(() => {
        var vh = window.innerHeight;
        var vw = window.innerWidth;
        var margin = 20;

        if (type === 'dropdown') {
          /* For dropdowns: cap the INNER LIST only.
             The dropdown itself keeps overflow:visible so submenus can pop out. */
          var innerList = panel.querySelector('.intention-ml__dropdown-list');
          if (innerList) {
            innerList.style.removeProperty('max-height');
            var listRect = innerList.getBoundingClientRect();
            var listAvail = vh - listRect.top - margin;
            if (listAvail < 200) listAvail = 200;
            if (innerList.scrollHeight > listAvail) {
              innerList.style.setProperty('max-height', listAvail + 'px', 'important');
            }
          }
        } else if (type === 'submenu') {
          /* For submenus: cap the submenu panel itself.
             Submenus have overflow-y:auto so max-height works directly. */
          panel.style.removeProperty('max-height');
          var rect = panel.getBoundingClientRect();
          var availBelow = vh - rect.top - margin;
          if (availBelow < 200) availBelow = 200;
          if (panel.scrollHeight > availBelow) {
            panel.style.setProperty('max-height', availBelow + 'px', 'important');
          }

          /* Flip left if overflows right viewport edge */
          if (rect.right > vw - margin) {
            panel.classList.add('intention-ml--flip-left');
          }
        }
      }, 50);
    }
    onResize() {
      if (!this.isMobileMode()) {
        this.closeAll();
      }
    }
    closeAll() {
      this.querySelectorAll('[data-nav-item].is-open').forEach((el) => {
        el.classList.remove('is-open');
        var dd = el.querySelector(':scope > [data-dropdown]');
        if (dd) {
          dd.classList.remove('intention-ml--flip-left');
          var list = dd.querySelector('.intention-ml__dropdown-list');
          if (list) list.style.removeProperty('max-height');
        }
      });
      this.querySelectorAll('[data-dropdown-item].is-open').forEach((el) => {
        el.classList.remove('is-open');
        var sm = el.querySelector(':scope > [data-submenu]');
        if (sm) {
          sm.classList.remove('intention-ml--flip-left');
          sm.style.removeProperty('max-height');
        }
      });
      this.updateAria();
    }
    updateAria() {
      this.querySelectorAll('[data-nav-item]').forEach((item) => {
        var btn = item.querySelector('[data-nav-trigger]');
        if (!btn) return;
        btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      });
      this.querySelectorAll('[data-dropdown-item]').forEach((item) => {
        var btn = item.querySelector('[data-submenu-trigger]');
        if (!btn) return;
        btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      });
    }
    handleNavClick(e, trigger) {
      var item = trigger.closest('[data-nav-item]');
      if (!item) return;
      e.preventDefault();
      e.stopPropagation();
      var mobile = this.isMobileMode();
      var isOpen = item.classList.contains('is-open');
      var siblings = item.parentElement ? item.parentElement.querySelectorAll('[data-nav-item].is-open') : [];
      siblings.forEach((sib) => { if (sib !== item) sib.classList.remove('is-open'); });
      if (isOpen) item.classList.remove('is-open');
      else {
        item.classList.add('is-open');
        if (!mobile) {
          var dropdown = item.querySelector(':scope > [data-dropdown]');
          if (dropdown) this.positionPanel(dropdown, item, 'dropdown');
        }
      }
      if (mobile && isOpen) {
        item.querySelectorAll('[data-dropdown-item].is-open').forEach((el) => el.classList.remove('is-open'));
      }
      this.updateAria();
    }
    handleSubmenuClick(e, trigger) {
      var item = trigger.closest('[data-dropdown-item]');
      if (!item) return;
      e.preventDefault();
      e.stopPropagation();
      var isOpen = item.classList.contains('is-open');
      var scope = item.parentElement ? item.parentElement.querySelectorAll('[data-dropdown-item].is-open') : [];
      scope.forEach((sib) => { if (sib !== item) sib.classList.remove('is-open'); });
      if (isOpen) item.classList.remove('is-open');
      else {
        item.classList.add('is-open');
        if (!this.isMobileMode()) {
          var submenu = item.querySelector(':scope > [data-submenu]');
          if (submenu) this.positionPanel(submenu, item, 'submenu');
        }
      }
      this.updateAria();
    }
    onDocClick(e) {
      if (this.isMobileMode()) return;
      if (!this.contains(e.target)) this.closeAll();
    }
  }
  customElements.define('intention-multilevel-nav', IntentionMultilevelNav);
})();
